import type { TaskDevice } from '@/task-manager/entities/task-device';

import type { GetCardDetailViewOutputDevice } from '../fetch-client';

import { alertLevelMapper } from './alert-level';

export function deviceMapper(
  data: GetCardDetailViewOutputDevice,
): TaskDevice | undefined {
  if (!data.accure_id) {
    return undefined;
  }

  return {
    id: data.accure_id,
    level: data.level ? alertLevelMapper(data.level) : undefined,
    fullFrontendId: data.full_frontend_id ?? undefined,
    frontendLevel: data.frontend_level ?? undefined,
    groupFrontendId: data.frontend_site_id ?? undefined,
    topFrontendId: data.frontend_top_id ?? undefined,
    unitFrontendId: data.frontend_unit_id ?? undefined,
    unitType: data.unit_type,
    cellType: data.cell_type,
  };
}
